import React, { useState, useEffect } from 'react';

const PHILOSOPHIES = [
    {
        id: null,
        label: 'None',
        icon: '🚫',
        description: 'No specific dietary restrictions beyond exclusions.',
        color: 'var(--philosophy-none)'
    },
    {
        id: 'Vegan',
        label: 'Vegan',
        icon: '🌱',
        description: 'Plant-based excellence. No animal products.',
        color: 'var(--philosophy-vegan)'
    },
    {
        id: 'Vegetarian',
        label: 'Vegetarian',
        icon: '🥚',
        description: 'No meat or fish. Eggs/dairy okay.',
        color: 'var(--philosophy-vegetarian)'
    },
    {
        id: 'Gluten-Free',
        label: 'G-Free',
        icon: '🌾',
        description: 'Zero wheat, barley, or rye. Celiac-safe.',
        color: 'var(--philosophy-gluten-free)'
    },
    {
        id: 'Paleo',
        label: 'Paleo',
        icon: '🦴',
        description: 'Ancestral whole foods. No grains/dairy.',
        color: 'var(--philosophy-paleo)'
    },
    {
        id: 'Mediterranean',
        label: 'Med.',
        icon: '🫒',
        description: 'Heart-healthy grains, fish & healthy fats.',
        color: 'var(--philosophy-mediterranean)'
    }
];

export const DietPhilosophySelector = ({ value, onChange, isLoading }) => {
    const [localValue, setLocalValue] = useState(value);
    const [isTransitioning, setIsTransitioning] = useState(false);

    useEffect(() => {
        setLocalValue(value);
    }, [value]);

    const handleSelect = (philosophy) => {
        if (isLoading) return;

        setIsTransitioning(true);
        setLocalValue(philosophy);
        onChange(philosophy);

        setTimeout(() => {
            setIsTransitioning(false);
        }, 300);
    };

    const activePhilosophy = PHILOSOPHIES.find(p => p.id === localValue);

    return (
        <div className="animate-enter" style={{ animationDelay: '0.1s' }}>
            <div className="flex items-center gap-4 mb-6">
                <div className="h-px bg-[var(--glass-border)] flex-1" />
                <span className="text-[10px] font-black text-[var(--text-secondary)] uppercase tracking-[0.3em] whitespace-nowrap">Diet Style (Optional)</span>
                <div className="h-px bg-[var(--glass-border)] flex-1" />
            </div>

            <div className="relative group">
                <div className="flex gap-4 overflow-x-auto pb-6 pt-2 px-2 no-scrollbar scroll-smooth">
                    {PHILOSOPHIES.map((phi) => (
                        <button
                            key={phi.id}
                            onClick={() => handleSelect(phi.id)}
                            disabled={isLoading}
                            className={`philosophy-chip shrink-0 ${localValue === phi.id ? 'active' : ''}`}
                            style={{
                                '--active-philosophy-color': phi.color,
                            }}
                        >
                            <span className="text-2xl mb-1">{phi.icon}</span>
                            <span className="text-[10px] font-black uppercase tracking-widest">{phi.label}</span>
                        </button>
                    ))}
                </div>
                {/* Scroll shadows */}
                <div className="absolute left-0 top-0 bottom-6 w-12 bg-gradient-to-r from-[var(--bg-gradient-start)] to-transparent pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity" />
                <div className="absolute right-0 top-0 bottom-6 w-12 bg-gradient-to-l from-[var(--bg-gradient-start)] to-transparent pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>

            <div className={`text-center mt-2 h-12 flex flex-col justify-center transition-all duration-300 ${isTransitioning ? 'opacity-0 translate-y-2' : 'opacity-100 translate-y-0'}`}>
                <p className="text-sm font-bold text-[var(--text-primary)]" style={{ color: activePhilosophy?.color }}>
                    {activePhilosophy ? activePhilosophy.description : 'Standard selection'}
                </p>
                {activePhilosophy && activePhilosophy.id && (
                    <p className="text-[10px] text-[var(--text-secondary)] font-black uppercase tracking-widest mt-1">
                        Chef will strictly enforce {activePhilosophy.id} guidelines
                    </p>
                )}
            </div>

            {isLoading && (
                <div className="h-0.5 w-full bg-transparent overflow-hidden mt-4">
                    <div className="h-full bg-[var(--accent-color)] animate-shimmer" style={{ width: '100%' }} />
                </div>
            )}
        </div>
    );
};
